// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"16ba0c85","793":"2ad12ea9"}[chunkId] + ".chunk.js";
};